import * as PIXI from 'pixi.js'
import isMobile from '../common/is-mobile.js';

// console.log(size)

// var confetti = function() {
//   var w = $("#l-contents").width(); // canvasの横幅
//   var h_hero = $(".top-hero").height();
//   var h_about = $(".top-about").height();
//   var h_bottom = $(".top-about-bottom").height();
//   var size = !isMobile(767) ? 9 : 13;
//   var h = h_hero + h_about + h_bottom;// canvasの縦幅
//   var app = new PIXI.Application(w, h, { antialias: true, transparent: true, autoResize: true, resolution: 2}); // 新規アプリ作成
//   document.getElementById('js-confetti').appendChild(app.view); // #confettiの中にcanvas追加

//   var color = [0x22e9ff, 0xff463f, 0x22ea3f, 0xffff3f]; // 紙吹雪の色
//   var xAdd = []; // 紙吹雪の進む方向（X軸）
//   var graphics = []; // 紙吹雪のグラフィック格納用
//   var scale = []; // 大きさ
//   for (var i = 0; i < 50; i++) { // 紙吹雪40個作成
//     var colornum = i % color.length // 色
//     scale.push(((Math.floor(Math.random() * 4) + 8) / size)); // 大きさに少しだけ変化つける
//     var x = Math.floor(Math.random() * w) + 10 // X軸ランダム
//     var y = Math.floor(Math.random() * h) // Y軸ランダム
//     xAdd.push(i % 2 === 0 ? 1 : -1); // 紙吹雪の進む方向（X軸）をばらばらに
//     graphics.push(new PIXI.Graphics().beginFill(color[colornum], 1).drawRect(-5, -5, 10, 10)); // graphicsに格納
//     graphics[i].position.x = x; // X軸
//     graphics[i].position.y = y; // Y軸
//     graphics[i].scale.x = scale[i]; // 横幅
//     graphics[i].scale.y = scale[i]; // 縦幅
//     graphics[i].skew.y = i % 10 * 0.1; // 傾き
//     graphics[i].rotation = 0.1 + ((i % 5) * 0.1); // 回転
//     app.stage.addChild(graphics[i]); // アプリに紙吹雪追加
//   }


//   animate(); // アニメーション実行
//   function animate() {
//     requestAnimationFrame(animate); // ブラウザにアニメーションを要求
//     var skew = [0.02, 0.04, 0.06, 0.08, 0.1]; // 傾き
//     var xPlus = [0.05, 0.1, 0.15, 0.2, 0.25]; // x軸の移動
//     for (var i = 0; i < 50; i++) { // 紙吹雪分ループ
//       var y,x;
//       var colornum = i % color.length; // 色
//       graphics[i].clear(); // グラフィック初期化
//       graphics[i].beginFill(color[colornum], 1).drawRect(-5, -5, 10, 10); // グラフィック作成
//       if(graphics[i].y > h) { // Y軸の最下部まで来たら最上部に戻す
//         y = -10
//         x = Math.floor(Math.random() * w) + 10;
//       } else {
//         y = graphics[i].y + 0.2 + ((i % 5) * 0.1);
//       }
//       if (graphics[i].x > w - 10) { // X軸の端まで来たら折り返す
//         xAdd[i] = -1;
//       } else if (graphics[i].x < 10) {
//         xAdd[i] = 1;
//       }
//       if(xAdd[i] === -1) { // 紙吹雪の進むX軸方向をバラバラに
//         x = graphics[i].x - xPlus[i % 5];
//       } else {
//         x = graphics[i].x + xPlus[i % 5];
//       }
//       graphics[i].scale.x = scale[i]; // 横幅
//       graphics[i].scale.y = scale[i]; // 縦幅
//       graphics[i].position.x = x; // X軸
//       graphics[i].position.y = y; // Y軸
//       graphics[i].skew.y += i % 2 === 0 ? skew[i % 5] : skew[i % 5] * -1; // 傾き
//       graphics[i].rotation += i % 2 === 0 ? (0.01 + ((i % 5) * 0.01)) : (0.01 + ((i % 5) * -0.01)); // 回転
//     }
//   }
// }

// confetti();

var result = getRandom(0, 1);


function getRandom(min, max) {
  var random = Math.floor(Math.random() * (max + 1 - min)) + min;
  return random;
}


var w = $('.top-confetti').width();
var h = $('.js-confetti-line').offset().top;
$('#js-confetti-stage').attr('width', w);
$('#js-confetti-stage').attr('height', h);

// $(window).on('resize', function () {
//   var w = $('.top-confetti').width();
//   var h = $('.top-campaignDetail').offset().top;
//   $('#js-confetti-stage').attr('width', w);
//   $('#js-confetti-stage').attr('height', h);
// }).trigger('resize');


var imgs = [
  './assets/img/top/hirahira01.png',
  './assets/img/top/hirahira02.png',
  './assets/img/top/hirahira03.png',
  './assets/img/top/hirahira04.png'
];

var imgArr = [];

var canvas = document.getElementById("js-confetti-stage");
var ctx = canvas.getContext("2d");
var imgCnt = 30;          // 描画する画像の数
var aryImg = [];          // 画像の情報を格納
var cvsw = w;           // canvasタグに指定したwidth
var cvsh = h;           // canvasタグに指定したheight
var imgBaseSizeW = 10;    // 画像の基本サイズ横幅
var imgBaseSizeH = 10;  // 画像の基本サイズ立幅
var aspectMax = 1;      // アスペクト比計算時の最大値
var aspectMin = 1;      // アスペクト比計算時の最小値
var speedMax = 0.2;         // 落下速度の最大値
var speedMin = 0.1;       // 落下速度の最小値
var angleAdd = 1;         // 画像角度への加算値

// 画像の読み込み
var img4 = new Image();
img4.src = imgs[3];
img4.onload = flow_start;

var img3 = new Image();
img3.src = imgs[2];
img3.onload = flow_start;

var img = new Image();
img.src = imgs[1];
img.onload = flow_start;

var img2 = new Image();
img2.src = imgs[0];
img2.onload = flow_start;

var array = [img, img2, img3, img4];
// console.log(array[Math.floor(Math.random() * array.length)]);

// 画像のパラメーターを設定
function setImagas() {
  var aspect = 0;
  for (var i = 0; i < imgCnt; i++) {
    // 画像サイズに掛けるアスペクト比を0.5~1.5倍でランダムで生成
    aspect = Math.random() * (aspectMax - aspectMin) + aspectMin;
    aryImg.push({
      "imgxx": array[Math.floor(Math.random() * array.length)],
      "posx": Math.random() * cvsw,   // 初期表示位置x
      "posy": Math.random() * cvsh,   // 初期表示位置y
      "sizew": imgBaseSizeW * aspect, // 画像の横幅
      "sizeh": imgBaseSizeH * aspect, // 画像の縦幅
      "speedy": Math.random() * (speedMax - speedMin) + speedMin,　// 画像が落ちていく速度
      "angle": Math.random() * 360,   // 角度
    });
  }
}

// 描画、パラメーターの更新
var idx = 0;
var cos = 0;
var sin = 0;
var rad = Math.PI / 180;
function flow(aaa) {
  // console.log(getRandom(0,1))
  ctx.clearRect(0, 0, cvsw, cvsh);
  for (idx = 0; idx < imgCnt; idx++) {
    aryImg[idx].posy += aryImg[idx].speedy;
    aryImg[idx].angle += Math.random() * angleAdd;
    cos = Math.cos(aryImg[idx].angle * rad);
    sin = Math.sin(aryImg[idx].angle * rad);
    ctx.setTransform(cos, sin, sin, cos, aryImg[idx].posx, aryImg[idx].posy);
    ctx.drawImage(aryImg[idx].imgxx, 0, 0, aryImg[idx].sizew, aryImg[idx].sizeh);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    // 範囲外に描画された画像を上に戻す
    if (aryImg[idx].posy >= cvsh) {
      aryImg[idx].posy = -aryImg[idx].sizeh;
    }
  }
}

function flow_start() {
  setImagas();
  setInterval(flow, 10);
}